import Exercise from 'components/BlockToText/Exercise/Exercise'
import HtmlHead from 'components/shared/HtmlHead/HtmlHead'
import SiteHeader from 'components/shared/SiteHeader/SiteHeader'
import Footer from 'components/shared/Footer/Footer'
import { withRouter } from 'helpers/withRouter'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { fetchExercise } from 'redux/actions/ExerciseActions'
import { Helmet } from 'react-helmet'

export const ExerciseContainer = ({
  i18n,
  fetchExerciseAction,
  exercise,
  router: {
    params: { slug, complete },
  },
}) => {
  const [shouldRender, setShouldRender] = useState(false)
  const completePage = complete === 'complete'

  useEffect(() => {
    fetchExerciseAction(i18n.language, slug)
  }, [fetchExerciseAction, i18n.language, slug])

  useEffect(() => {
    setShouldRender(!exercise.error && !exercise.loading)
  }, [exercise])

  return (
    <div>
      <HtmlHead />
      <SiteHeader />
      <Helmet>
        <script
          defer
          data-domain={import.meta.env.VITE_PLAUSIBLE_DATA_DOMAIN}
          src={import.meta.env.VITE_PLAUSIBLE_SOURCE}
        ></script>
        <script>
          {`
            (window.plausible =
              window.plausible ||
              function (...args) {
                ;(window.plausible.q = window.plausible.q || []).push(...args)
              })`}
        </script>
      </Helmet>
      {shouldRender && (
        <Exercise
          name={exercise.name}
          steps={exercise.steps}
          codeTemplate={exercise.code}
          slug={slug}
          completePage={completePage}
        />
      )}
      <Footer
        text="project.footer.feedback.homepage.text"
        userID="excercise-footer-user-id"
      />
    </div>
  )
}

ExerciseContainer.propTypes = {
  i18n: PropTypes.object.isRequired,
  fetchExerciseAction: PropTypes.func.isRequired,
  exercise: PropTypes.object.isRequired,
  router: PropTypes.shape({
    params: PropTypes.shape({
      slug: PropTypes.string.isRequired,
      complete: PropTypes.string,
    }).isRequired,
  }).isRequired,
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchExerciseAction: (locale, slug) =>
      dispatch(fetchExercise(locale, slug)),
  }
}

const mapStateToProps = ({ exercise = {} }) => {
  return { exercise }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation('translations')(withRouter(ExerciseContainer)))
